import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenVaccinationsIndicatorC3Data } from "@/services/esus/indicator/esf/c3/getDetailedCitizensVaccinationsIndicatorC3";

import { IndicatorEsfC3CitizensVaccinationsHistoryInfo } from "./IndicatorEsfC3CitizensVaccinationsHistoryInfo";
import { VaccinationCard } from "@/components/VaccinationCard";

type IndicatorEsfC3CitizensVaccinationsHistoryProps = {
	citizenWithVaccinations: DetailedCitizenVaccinationsIndicatorC3Data;
};

export function IndicatorEsfC3CitizensVaccinationsHistory({
	citizenWithVaccinations,
}: Readonly<IndicatorEsfC3CitizensVaccinationsHistoryProps>) {
	const indicatorEsfC3CitizensVaccinationsHistoryInfo = {
		fullName: citizenWithVaccinations.fullName ?? "N/A",
		birthdate: citizenWithVaccinations.birthdate
			? dayjs(citizenWithVaccinations.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithVaccinations.cpf
			? formatIdentifier(citizenWithVaccinations.cpf)
			: citizenWithVaccinations.cns ?? "",
		motherName: citizenWithVaccinations.motherName ?? "",
		phone: citizenWithVaccinations.phone ? phoneFormat(citizenWithVaccinations.phone) : "",
		address:
			addressConcat(
				citizenWithVaccinations.street,
				citizenWithVaccinations.houseNumber,
				citizenWithVaccinations.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC3CitizensVaccinationsHistoryInfo
				{...indicatorEsfC3CitizensVaccinationsHistoryInfo}
			/>
			<VaccinationCard
				vaccinations={(citizenWithVaccinations.vaccines ?? []).map((vaccine) => {
					return {
						id: vaccine.id,
						dateofVaccine: dayjs(vaccine.dateofVaccine).format("DD/MM/YYYY"),
						immunobiological: vaccine.immunobiological,
						immunobiologicalDosage: vaccine.immunobiologicalDosage,
						professional: vaccine.professional,
						healthTeam: vaccine.healthTeam,
						healthUnit: vaccine.healthUnit,
						status: "vaccinated",
						healthTeamId: vaccine.healthTeamId,
						healthUnitId: vaccine.healthUnitId,
					};
				})}
			/>
		</>
	);
}
